import { useMemo } from 'react';
import { useDataFetch } from './Use-data-fetch';

/**
 * Resumen mes a mes de usuarios: afiliados nuevos, cuántos de ellos se
 * activaron en el mismo mes y la conversión entre ambos.
 *
 * Lo consumen la gráfica comparativa y la tabla de resumen del tablero, que
 * antes tenían los tres meses escritos a mano.
 */
export const useMonthlyUsers = (months = 3,province,city) => {
  const { getData } = useDataFetch();

  const { data, isLoading, error } = getData(
    ['monthly-users-summary', months,province,city],
    '/users/monthly-summary',
    {},
    { months,province,city }
  );

  const summary = useMemo(() => {
    const rows = data?.data?.months ?? [];

    return {
      rows,
      categories: rows.map((row) => row.month),
      newUsers: rows.map((row) => row.new_users),
      activeUsers: rows.map((row) => row.active_users),
      activation: rows.map((row) => row.activation_percentage ?? 0),
      totals: data?.data?.totals ?? null,
    };
  }, [data]);

  return { ...summary, isLoading, error };
};
